"use client"

import { useModal, useModalComponent } from "./ModalContext"
import { ModalShell, type ModalShellProps } from "./ModalShell"

import type { ModalId } from "./modal.types"
import type { ReactNode } from "react"

export interface ModalProps extends Omit<ModalShellProps, "open" | "onClose"> {
  id: ModalId
  testId?: string
  onClose?: () => void
  children: ReactNode
}

export function Modal({ id, testId, children, onClose, ...shell }: ModalProps) {
  const { isOpen, close, mountKey } = useModal(id)

  const onCloseShell = () => {
    onClose?.()
    close()
  }

  // Track Modal component for duplicate detection
  useModalComponent(id)

  return (
    <ModalShell open={isOpen} onClose={onCloseShell} {...shell}>
      {isOpen && (
        <div data-testid={testId ?? id} key={mountKey}>
          {children}
        </div>
      )}
    </ModalShell>
  )
}
